import React from "react";
import { func } from "prop-types";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { RightArrowIcon } from "../../../../../assets/icons/RightArrowIcon";
import { SPONSORED_SESSIONS } from "../partnered-data";
import "./sponsored-sessions-section.m.css";

export const SponsoredSessionsSection = ({ onPartnerFormOpen }) => {
  const sponsorImage = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "static_pages_images", "sponsor_session"])
  );

  return (
    <section id="sponsored-sessions" styleName="sponsored-section">
      <div styleName="centered">
        <div styleName="content-container">
          <p styleName="research-eyebrow">{SPONSORED_SESSIONS.eyebrow}</p>
          <h2 styleName="research-headline">{SPONSORED_SESSIONS.headline}</h2>
          <div styleName="research-separator" />
          <p styleName="sponsored-description">
            <span styleName="highlight-text">{SPONSORED_SESSIONS.highlight}</span>{" "}
            {SPONSORED_SESSIONS.text}
          </p>

          <div styleName="sponsored-media">
            <img
              src={sponsorImage}
              alt=""
              styleName="sponsored-image"
            />
            <div styleName="sponsored-black-box">
              <div styleName="sponsored-points">
                {SPONSORED_SESSIONS.points.map(({ strong, text }) => (
                  <p key={`${strong}-${text}`}>
                    <strong>{strong}</strong> {text}
                  </p>
                ))}
              </div>
              <a href="/events" styleName="sponsored-link">
                {SPONSORED_SESSIONS.linkText}
                <RightArrowIcon stroke="var(--red)" />
              </a>
            </div>
          </div>
          <button
            styleName="research-button"
            onClick={() => onPartnerFormOpen("Collaborate on a sponsored session")}
          >
            {SPONSORED_SESSIONS.cta}
          </button>
        </div>
      </div>
    </section>
  );
};

SponsoredSessionsSection.propTypes = {
  onPartnerFormOpen: func.isRequired,
};
